import { CustomAvatar } from "./CustomAvatar";
import {useImageLoader} from "../customHook/ImageLoader";
import {Avatar} from "antd";

const avatarSize = 22;
const overlap = 5;

const positionsForCount = {
  2: [
    { left: 0, top: 0 },
    { left: avatarSize - overlap, top: avatarSize - overlap },
  ],
  3: [
    { left: avatarSize / 2 - overlap / 2, top: 0 },
    { left: 0, top: avatarSize - overlap },
    { left: avatarSize - overlap, top: avatarSize - overlap },
  ],
  4: [
    { left: 0, top: 0 },
    { left: avatarSize - overlap, top: 0 },
    { left: 0, top: avatarSize - overlap },
    { left: avatarSize - overlap, top: avatarSize - overlap },
  ],
};

const OverlappedAvatars = ({ conversationAvatar, images, totalMember }) => {
  const count = Math.min(images?.length, 4);
  const positions = positionsForCount[count] || [];
  const { imageUrl, error: imageError } = useImageLoader(conversationAvatar);

  const containerSize =
    count === 2
      ? avatarSize + (avatarSize - overlap)
      : avatarSize * 2 - overlap;

  if (imageUrl && !imageError) {
    return (
      <CustomAvatar
        conversationAvatar={conversationAvatar}
        size={50}
        pos={-1}
      />
    );
  }

  if (images?.length === 1) {
      return (
          <CustomAvatar
              person={{
                  avatar: images?.[0]?.avatar,
                  name: images?.[0]?.name,
                  userId: images?.[0]?.userId,
              }}
              size={50}
              pos={-1}
              styleCss={{}}
          />
      );
  }

  return (
    <div
      style={{
        position: "relative",
        width: containerSize,
        height: containerSize,
      }}
    >
      {images?.slice(0, 4)?.map((src, index) => {
        const pos = positions[index];

        if (totalMember > 4 && index === 3) {
            return <Avatar
                    size={avatarSize}
                    style={{
                        ...pos,
                        zIndex: 10,
                        width: avatarSize,
                        height: avatarSize,
                        borderRadius: "50%",
                        backgroundColor: "gray",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                        color: "#fff",
                        fontWeight: 500,
                        userSelect: "none",
                    }}
                    key={index}
                >
                {totalMember > 99 ? '99+' : totalMember}
                </Avatar>
        }

        return (
          <CustomAvatar
            size={avatarSize}
            person={{
              avatar: src?.avatar,
              name: src?.name,
              userId: src?.userId,
            }}
            key={index}
            index={index}
            pos={pos}
            isOnline={false}
          />
        );
      })}
    </div>
  );
};

export default OverlappedAvatars;
